import bill from './layers/bill.png'
import flap from './layers/flap.png'
import React, { useEffect, useState } from "react";

export default function ReceiptSVGInside(props) {

    const [filter, setFilter] = useState(null)
    const [isMagnified, setIsMagnified] = useState(false);
    const [magnifiedX, setMagnifiedX] = useState(0);
    const [magnifiedY, setMagnifiedY] = useState(0);
  
    const toggleMagnifier = () => {
      setIsMagnified(!isMagnified);
    };
  
    const handleMouseMove = (e) => {
      if (isMagnified) {
        const svgRect = e.currentTarget.getBoundingClientRect();
        const offsetX = e.clientX - svgRect.left;
        const offsetY = e.clientY - svgRect.top;
  
        // Set the magnified position to create a zoom effect
        setMagnifiedX(offsetX);
        setMagnifiedY(offsetY);
      }
    };
    useEffect(() => {
        const rgb = hexToRgb(props.flipColor);
        setFilter(`${rgb.r / 255} 0 0 0 0  0 ${rgb.g / 255} 0 0 0  0 0 ${rgb.b / 255} 0 0  0 0 0 1 0`)
        // Helper function to convert HEX color to RGB
        function hexToRgb(hex) {

            if (hex.length === 4) {
                hex = "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }

            const bigint = parseInt(hex.slice(1), 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return { r, g, b };
        }
    }, [props.flipColor])

    
    return (
        <>

            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" className="svgProduct hover-magnify" >

                <title>5</title>
                <defs>
                    <image width="475" height="336" id="riimg5" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAdsAAAFQAQMAAADNw0ZsAAAAAXNSR0IB2cksfwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5TAP9bkSK1AAAAWUlEQVR4nO3LMQEAAAQAMM1pTgcOz/Yv4iJ7rWRZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmVZlmX5Pb8ZYzp2tmDxMu0AAAAASUVORK5CYII=" />
                    <image width="38%" id="riimg6" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOsAAAFOCAMAAABQchoOAAAAAXNSR0IB2cksfwAAAXdQTFRF////hIODeXh4j46OpaWlbW1tmpqa9PT0YmFh0tLSsbCwV1ZWvLu76ejox8fH3d3d9vb26urq+/v7/Pz8+vr6mZiY39/fysrKenl5k5KSlpWVlZSUfXx8r66u8PDw6enp/f391dXVu7u7WFdXYF9fqqqq7+/v9fX1fHt7nJubkJCQ2dnZqKioWllZfn19ra2ta2pq4uLicG9v+fn5pqamurq6Z2dnaWhomZmZtLS0xsXFuLe3e3p6bGtrwsHB9/f3gH9/0tHRWVhYsK+vYWBg6+vrq6qq6+rqb29viomJxcXFtbW1Xl1d8vLypKSkioqKyMfHs7Oz0M/Pvb29amlpwL+/1tbWtLOzraysqampgYCA/v7+g4KCdnV1+Pj4bWxs1NPTb25uZGNjxsbGubm54eHhoaCg5eTklJOTz8/Pw8PDZWVl29vbvr298fDwf35+cXFxrq2td3Z2mJiY6OjojYyMiIeHi4qKhYSE5+bmoqKigoGBo6KiuaoYzgAAA8ZJREFUeJzt14lzFEUUx/Geu6ffHMLGRUAl6wWC8T4xCkaNJ0ZFRcH7RvHCA68/3te9s0lMjFWSJbMx30+lenu7J6n32+59VTEGAAAAAAAAAAAAAAAAwF4XxTokYUizfONuYcsNK06KyRCPVyoRd83LnIrKl22lNiarN2et7MalWhr9WKQyJq/GK81q6llX6KG0URhMlsQSFyYVybrjjP1HUUkktZ5e1oalRD+WMBRtJj6023T4sypJTNokkXHOZLZupKqkNLkt/F6pa06z6ichrcnD8TlrmtTZok2M9XtFk/Ub4D/QaqOikUIPNEv0ilaRnlkr4agi0dPUJ2r9hnp+TS9xWhY6NGVYK1vZJVc4XGINZ/2g39e/Za01RClNyGpXfyFOM38bIt1q+yv76sTjbuMmWd3qHc59f80in7Vc67WppL4TJ9qko7CwuaXNrNTnCu14nFVzj3tT7buzRnP+VS9xNo7b+DMP7bjU3qS59eoDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGZTLqqbR7n/+aeHojC6Havq2siztfneyJqKZGWXtY1FkiJLjLGpKWxt1mXVW1D1Wu62+DscVVKa3BbjrFlkWutSa0qJTRPOeZK1lca0/da7HeFcIz3EVsqQtRRNk0SttKmTOgnR8jiMrhab172Wuy1bZTVxGhvrovFD1o+JM2Uu2b/9tdkWsrp1d7iw4Q4bp9/W1I7bUSV6lZ0tdJraXsvdlnFvStb1pjLT3uTPuTGNdDfW6bc6Ln3bsru4NwEAAADYO67bt7+bDQo1t8Vjc/u22tk9rhcZjmcHbjh46NDhG29at3nzETPfTUdyyw5XNnX7b73t9jvC7OixOTOYG9x5/ER4e9dRY5oFufue7sGR3HtfTzVOywm5f/hAmA0fNA89/Mijj518PLxdfOLJU6f1n/SnugdHsiRP91TklDyjcZ4Ns+Hyc88XgxdePPBSeHtQN5ZEXg5vzryyMpJXX3u9tzKn4qy88eYgzIbLbx035tzbXdZ3JDjv5xcWl94dyai/KqejkPe62XD5/Q9OfvhR22UtPg5ZPwlb8qn5X2X97HPzxZcrF81XXb+9+LVGPRyml+Ss+UYu9VPh9KxlHSyGPvvtd0f8y9y570XsD/Nh68LlhWMLl+f7qG+aTp3/cTL96edfrlxZ+XVyVX8btYPJ1pnf//iz2PHaAAAAAAAAAAAAAABX5y8YVT1YGimstwAAAABJRU5ErkJggg==" />
                    <image width="28%" id="riimg8" href={bill} />
                    <image width="40%" id="riimg9" href={flap} />
                </defs>
                <style>
                </style>
                <g id="Inside">
                    {/* <use id="WALLET SHADOW" href="#img5" x="316" y="21" /> */}
                    <use id="WALLET LHS" href="#riimg6" x="12%" y="20%" />
                    <foreignObject x="18.5%" y="32%" width="25%" height="30%" >
                        <p xmlns="http://www.w3.org/1999/xhtml" style={{ fontSize: "40%", textAlign: "center" }}>{props.introText}</p>
                    </foreignObject>
                    <use id="WALLET RHS IMAGE" href="#riimg7" /> 
                   <image width="38%" xlinkHref={props.rhsBG} x="50%" y="20%" />
                    <use id="WALLET RECEIPT" href="#riimg8" x="57%" y="25%" />
                    <use id="WALLET FLAP" href="#riimg9" x="49%" y="56.4%" style={{ filter: "url(#ricolorize)" }} />
                    <text id="www.parifypackaging.co.uk">
                        <tspan x="63%" y="65%" style={{ fontSize: props.pdf? "40%":"60%", fill: "#fff", fontFamily: "AmalfiCoast" }}>Thank You!</tspan>
                    </text>
                </g>
                <filter id="ricolorize">
                    <feColorMatrix type="matrix" values={filter} />
                </filter>
            </svg>
        </>
    )
}